import { render, staticRenderFns } from "./PosHistoryImport.vue?vue&type=template&id=16afffd7&scoped=true&"
import script from "./PosHistoryImport.vue?vue&type=script&lang=js&"
export * from "./PosHistoryImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afffd7",
  null
  
)

export default component.exports